module.exports = __webpack_public_path__ + "static/media/eco.f11da6d5.svg";